/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Tooltip,
  ListItemIcon,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon as MUIListItemIcon,
  ListItemText,
  Divider,
  Typography,
} from "@mui/material";
import Logout from "@mui/icons-material/Logout";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import PeopleIcon from "@mui/icons-material/PeopleOutlineOutlined";
import ElectricMopedOutlinedIcon from "@mui/icons-material/ElectricMopedOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import ViewCompactAltOutlinedIcon from "@mui/icons-material/ViewCompactAltOutlined";
import GpsFixedOutlinedIcon from "@mui/icons-material/GpsFixedOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";

const AppHeader: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorNl, setAnchorNl] = useState<null | HTMLElement>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [userName, setUserName] = useState<string | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setUserRole(localStorage.getItem("authority"));
    setUserName(localStorage.getItem("name"));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const notificationhandleClick = () => {
    navigate("/notificationList");
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [openEVMenu, setOpenEVMenu] = useState(false);

  const handleEVMenuClick = () => {
    setOpenEVMenu(!openEVMenu);
  };

  const isMenuItemActive = (path: string) => location.pathname === path;

  const menuItems = [
    {
      label: "Overview",
      icon: <ViewCompactAltOutlinedIcon />,
      path: "/overview",
    },
    { label: "Rider Details", icon: <PeopleIcon />, path: "/userdetails" },
    {
      label: "EV Details",
      icon: <ElectricMopedOutlinedIcon />,
      path: "/evdetails",
    },
    {
      label: "Payment",
      icon: <PaymentOutlinedIcon />,
      path: "/paymentdetails",
    },
    {
      label: "IOT Details",
      icon: <GpsFixedOutlinedIcon />,
      path: "/iotdetails",
    },
    {
      label: "Ride End Request",
      icon: <PeopleIcon />,
      path: "/rideendrequest",
    },
    {
      label: "Wallet Deduction",
      icon: <PeopleIcon />,
      path: "/walletDeduction",
    },
    {
      label: "Reports",
      icon: <AssessmentOutlinedIcon />,
      path: "/reports",
    },
    {
      label: "EV Plans",
      icon: <PlaylistAddCheckOutlinedIcon />,
      path: "/evplans",
    },
  ];

  return (
    <div className="w-full text-sm text-[#455A64] font-rubik font-semibold">
      <AppBar
        position="sticky"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #EBEBEB",
          boxShadow: "0px 4px 30px 4px #00000005",
        }}
      >
        <Toolbar className="justify-between">
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
          >
            <MenuIcon sx={{ color: "#000" }} /> {/* Set the color here */}
          </IconButton>

          <div className="flex items-center">
            <Tooltip title="Notification">
              <IconButton onClick={notificationhandleClick}>
                <NotificationsOutlinedIcon color="success" fontSize="large" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Account">
              <IconButton
                onClick={handleClick}
                size="small"
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <AccountCircleOutlinedIcon color="success" fontSize="large" />
              </IconButton>
            </Tooltip>

            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
            >
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>

            <Typography variant="body1" className="ml-2 text-black">
              {userName || "User"}
            </Typography>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerToggle}>
        <Box sx={{ width: 250 }} role="presentation">
          <Typography variant="h6" sx={{ p: 2 }}>
            Menu
          </Typography>
          <Divider />

          <List>
            {menuItems.map((item) => {
              if (item.label === "EV Details") {
                return (
                  <React.Fragment key={item.label}>
                    <ListItem disablePadding>
                      <ListItemButton onClick={handleEVMenuClick}>
                        <MUIListItemIcon>{item.icon}</MUIListItemIcon>
                        <ListItemText primary={item.label} />
                        {openEVMenu ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                    </ListItem>

                    <Collapse in={openEVMenu} timeout="auto" unmountOnExit>
                      <List
                        component="div"
                        disablePadding
                        sx={{
                          backgroundColor: "#F5F5F5", // light grey
                          mx: 1,
                          borderRadius: 1,
                          mb: 1,
                        }}
                      >
                        <ListItemButton
                          sx={{ pl: 4 }}
                          selected={isMenuItemActive("/evdetails/ev-details-list")}
                          onClick={() => {
                            navigate("/evdetails/ev-details-list");
                            setDrawerOpen(false); 
                          }}
                        >
                          <ListItemText primary="EV Detail List" />
                        </ListItemButton>

                        <ListItemButton
                          sx={{ pl: 4 }}
                          selected={isMenuItemActive("/evdetails/ride-ended")}
                           onClick={() => {
                            navigate("/evdetails/ride-ended");
                            setDrawerOpen(false); 
                          }}
                      
                        >
                          <ListItemText primary="Ride Ended" />
                        </ListItemButton>
                        <ListItemButton
                          sx={{ pl: 4 }}
                          selected={isMenuItemActive(
                            "/evdetails/ready-for-allotment"
                          )}
                           onClick={() => {
                            navigate("/evdetails/ready-for-allotment");
                            setDrawerOpen(false); 
                          }}
                        
                        >
                          <ListItemText primary="Ready For Allotment" />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </React.Fragment>
                );
              }

              return (
                <ListItem key={item.label} disablePadding>
                  <ListItemButton
                    selected={isMenuItemActive(item.path)}
                    onClick={() => {
                      navigate(item.path);
                      setDrawerOpen(false); // 👈 normal menu click pe drawer close
                    }}
                  >
                    <MUIListItemIcon>{item.icon}</MUIListItemIcon>
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Drawer>
    </div>
  );
};

export default AppHeader;
